export const GaiaConstants = {
    colors: { darkGreen: "#0F3D2C", green: "#4A703F", gold: "#998D6B", accentGreen: "#C2DE54", lightGreen: "#205C40" },
};
